import React, { useEffect, useState } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { HiArrowCircleRight } from 'react-icons/hi';

import Text from './Text';

const AlertModal = ({ showModal, setShowModal }: any) => {
  const { query } = useRouter();
  const [filters, setFilters] = useState([]);
  useEffect(() => {
    const firstFourFilters: any = [
      query.governorate &&
        `Ville:&nbsp;<strong> ${decodeURIComponent(
          query.governorate as string
        )}</strong>`,
      ...(query.delegation
        ? decodeURIComponent(query.delegation as string)
            .split(',')
            .map((d) => `Délégation:&nbsp;<strong>${d}</strong>`)
        : []),
      query.q &&
        `Recherche:&nbsp;<strong>${decodeURIComponent(
          query.q as string
        )}</strong>`,
      query.category &&
        `Catégorie:&nbsp;<strong> ${decodeURIComponent(
          query.category as string
        )}</strong>`,
      query.subCategory &&
        `Sous-catégorie:&nbsp;<strong> ${decodeURIComponent(
          query.subCategory as string
        )}</strong>`,
      query.productType &&
        `État de produit:&nbsp;<strong>${decodeURIComponent(
          query.productType as string
        )}</strong>`,
      query.minPrice &&
        `Prix min:&nbsp;<strong>${decodeURIComponent(
          query.minPrice as string
        )}</strong>`,
      query.maxPrice &&
        `Prix max:&nbsp;<strong>${decodeURIComponent(
          query.maxPrice as string
        )}</strong>`,
    ].filter((f) => f);
    const newFilters: any = [];
    Object.entries(query).forEach(([key, value]) => {
      if (
        value &&
        key !== 'governorate' &&
        key !== 'delegation' &&
        key !== 'category' &&
        key !== 'subCategory' &&
        key !== 'productType' &&
        key !== 'minPrice' &&
        key !== 'maxPrice' &&
        key !== 'q' &&
        key !== 'page' &&
        key !== 'after_timestamp'
      ) {
        newFilters.push(
          `${key}:&nbsp;<strong>${decodeURIComponent(value as string)}</strong>`
        );
      }
    });
    setFilters(firstFourFilters.concat(newFilters));
  }, [query]);

  function checkos() {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'web';
  }

  const track = (event: string) => {
    // @ts-ignore
    if (window.rudderanalytics?.track) {
      window.rudderanalytics.track(event, {
        platform: checkos(),
      });
    }
  };

  return (
    <>
      {showModal && Object.keys(query).length > 0 && (
        <div className="  justify-center items-center flex overflow-x-hidden !overscroll-none !overflow-hidden overflow-y-auto fixed inset-0 !z-[9999] outline-none focus:outline-none">
          <div className="absolute w-full h-full bg-wihte backdrop-blur-sm "></div>
          <div className="flex justify-center items-center relative p-4 mt-16 lg:mt-0 w-[90%] max-w-md h-[90%] md:h-[96%] z-50">
            <div className="relative bg-white rounded-lg shadow">
              <div className=" flex flex-col p-3 lg:p-6 text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="relative top-0 left-0 lg:-top-2 lg:left-1 w-10 h-10 stroke-white fill-primary self-end cursor-pointer"
                  onClick={() => setShowModal(false)}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <img
                  src="/media/AlertAdded.svg"
                  alt="tayara illustration : alert added"
                  className="self-center items-center justify-center w-44 lg:w-60 h-44 lg:h-60 "
                />

                <h3 className="mb-5 text-lg lg:text-2xl font-extrabold text-gray-700 ">
                  {'Nous avons créé une alerte avec les filtres suivants : '}
                </h3>
                <div className="flex flex-wrap justify-center mb-5 text-sm lg:text-base">
                  {filters.map((filter) => (
                    <>
                      <span
                        id="badge-dismiss-default"
                        className="inline-flex items-center my-1 px-2 py-1 mr-2 text-sm font-medium rounded-md outline outline-1 outline-gray-400 text-gray-800 bg-gray-200/70"
                        dangerouslySetInnerHTML={{ __html: filter }}
                      ></span>
                    </>
                  ))}
                </div>
                <Link
                  href={'/profile/?t=myAlerts'}
                  replace
                  className="flex justify-center my-2 align-middle items-center text-xs font-normal text-gray-700 border-gray-300
            hover:text-info hover:border-gray-500
             w-full "
                  onClick={() => track('Visited saved search')}
                >
                  <Text
                    text="Voir mes recherches sauvegardées"
                    className="self-center"
                  />
                  <HiArrowCircleRight size={18} className="self-center ml-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlertModal;
